import myMatchesSendersService from './my-matches-senders-service'
import types from './types'

const fetchMyMatchesSenders = () => {
  return (dispatch) => {
    dispatch({ type: types.FETCH_MY_MATCHES_SENDERS_START })
    return myMatchesSendersService
      .getMyMatchesSenders()
      .then((senders) => {
        dispatch({
          type: types.FETCH_MY_MATCHES_SENDERS_SUCCESS,
          payload: senders,
        })
      })
      .catch(() => dispatch({ type: types.FETCH_MY_MATCHES_SENDERS_FAILURE }))
  }
}

const actions = {
  fetchMyMatchesSenders,
}

export default actions
